import { AppState, HomePageNewYorkAppState } from '../../../initialStateRegistration';
import { SectionNames, HomePageNewYorkMinorSections } from './homePageNewYork.initialState';

export const getHomePage = (state: AppState) => (state as HomePageNewYorkAppState).template;

export const getSectionDataByKey = (key: SectionNames) => (state: AppState) => getHomePage(state)[key];

export const getSectionArticlesByKey = (key: SectionNames) => (state: AppState) => getHomePage(state)[key].articles;

export const getSectionTitleByKey = (key: HomePageNewYorkMinorSections) => (state: AppState) => getHomePage(state)[key].sectionTitle;

export const getMoreButtonTextByKey = (key: HomePageNewYorkMinorSections) => (state: AppState) => getHomePage(state)[key].moreButtonText;

export const getMoreButtonSvgByKey = (key: HomePageNewYorkMinorSections) => (state: AppState) => getHomePage(state)[key].moreButtonSvg;

export const getMetadataDescription = (state: AppState) => getHomePage(state).metadataDescription;

export const getMetadataTitle = (state: AppState) => getHomePage(state).metadataTitle;

export const getMetadataAdsCategory = (state: AppState) => getHomePage(state).metadataAdsCategory;

export const getMetadataImage = (state: AppState) => getHomePage(state).metadataImage;
